import { DatePipe } from '@angular/common';
import { Component, inject, input, output, resource } from '@angular/core';
import { SimpleApi } from '@core/api/simple.api';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { LogMessage } from '@features/log/log-detail-messages/log.message.model';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { BatchJob } from '../batch-job/batch-job.model';
import { BatchJobParameterApi } from './batch-job-parameter.api';
import { AuthService } from '@core/auth/auth.service';
import { RettighedsType } from '@core/auth/rettighed.model';
import { ButtonModule } from 'primeng/button';
import { BatchService } from '../batch.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'app-batch-job-detail',
  imports: [
    ConfirmDialog,
    DatePipe,
    TableRowDirective,
    SkeletonModule,
    TableModule,
    ButtonModule,
  ],
  providers: [ConfirmationService],
  templateUrl: './batch-job-detail.component.html',
  styleUrl: './batch-job-detail.component.css',
})
export class BatchJobDetailComponent {
  closeWindowRequest = output();
  authService = inject(AuthService);
  confirmationService = inject(ConfirmationService);
  batchService = inject(BatchService);
  batchJob = input.required<BatchJob>();
  batchJobParameterApi = inject(BatchJobParameterApi);
  simpleApi = inject(SimpleApi);

  parameters = resource({
    params: () => this.batchJob().id,
    loader: async ({ params, abortSignal }) => {
      return await this.batchJobParameterApi.getList(
        {
          filter: JSON.stringify({
            batchJobId: params,
          }),
          sortBy: 'parameterNavn',
        },
        abortSignal
      );
    },
  });

  log = resource({
    params: () => this.batchJob().id,
    loader: async ({ params, abortSignal }) => {
      return await this.simpleApi.getList<LogMessage>(
        `/api/admin/batchjobs/log`,
        { batchJobId: params },
        abortSignal
      );
    },
  });

  allowEdit() {
    return this.authService.hasRettighed(RettighedsType.AdminBatchSkriv);
  }

  genstartJob(job: BatchJob) {
    this.confirmationService.confirm({
      // target: e.target as EventTarget,
      message:
        'Er du sikker at du vil genstartet jobbet <b>' +
        job.batchJobSchedule.jobNavn +
        '</b>?',
      header: 'Genstart job',
      rejectButtonProps: {
        label: 'Fortryd',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Genstart',
      },

      accept: () => {
        this.batchService.genstartJob(job);
        this.closeWindowRequest.emit();
      },
    });
  }
}
